import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // UI Components ------------------------------------------------------------
  // ['related-posts']: asyncComponentFactory('ui/related-posts'),
  Slider: asyncComponentFactory('ui/Slider'),
  // NAV Components ------------------------------------------------------------
  // DesktopNav: asyncComponentFactory('nav/DesktopNav'),
};

export default AppComponents;
